export { default as WalletModal } from "./WalletModal";
export { default as WalletInfoModal } from "./WalletInfoModal";
